export default "__VITE_ASSET__C1EcEKwn__"